import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminPartnerService } from '../services/admin-partner.service';

export function useAdminCommissions(params?: {
  page?: number;
  limit?: number;
  status?: string;
  partnerId?: string;
  from?: string;
  to?: string;
}) {
  return useQuery({
    queryKey: ['admin', 'commissions', 'list', params],
    queryFn: () => adminPartnerService.getCommissions(params),
  });
}

export function useAdminCommission(id: string) {
  return useQuery({
    queryKey: ['admin', 'commissions', id],
    queryFn: () => adminPartnerService.getCommissionById(id),
    enabled: !!id,
  });
}

export function useApproveCommission() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => adminPartnerService.approveCommission(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'commissions'] });
    },
  });
}

export function useCancelCommission() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) =>
      adminPartnerService.cancelCommission(id, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'commissions'] });
    },
  });
}

export function useBlockCommission() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) =>
      adminPartnerService.blockCommission(id, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'commissions'] });
    },
  });
}

export function useBulkApproveCommissions() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ids: string[]) => adminPartnerService.bulkApproveCommissions(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'commissions'] });
    },
  });
}

export function useProcessCommissionExpiration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => adminPartnerService.processCommissionExpiration(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'commissions'] });
    },
  });
}
